import { render, staticRenderFns } from "./SelfProvidedOAuthScreen.vue?vue&type=template&id=11daa59a&"
import script from "./SelfProvidedOAuthScreen.vue?vue&type=script&lang=js&"
export * from "./SelfProvidedOAuthScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports